import { Box, Button, Card,CardHeader,CardContent,CircularProgress,Grid,Modal, Paper, Stack, Typography } from '@mui/material';
import React,{useContext, useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { isMobile } from 'react-device-detect';
import AddRole from './AddRole';
import UserList from './UserList';
import Permissions from './Permissions';
import CircleIcon from '@mui/icons-material/Circle';
import { ArrowBack, EditOutlined } from '@mui/icons-material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { RoleAndPermissionServices } from '../RoleAndPermissionServices';
import Swal from 'sweetalert2';
import { RoleDataContext } from '.';
import { PermissionGuard } from '../../../components/PermissionGuard';
import RoleList from './RoleList';
import LoadingOverlay from '../../../components/Layout/LoadingOverlay';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';

const style = {
    position: 'absolute',
    top: (isMobile) ? '80%' : '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #ddd',
    boxShadow: 24,
    p: 2,
};

const ViewRole = () => {
    const {actionTab,setActionTab,selectedRole,setSelectedRole,roleList,setRoleList} = useContext(RoleDataContext);
    const {id} = useParams();
    const [searchParams] = useSearchParams();
    const roleTitle = searchParams.get('role');

    const menuDispatch = useDispatch();
    menuDispatch({
        type: 'menuSelect',
        payload: 'roles'
    });
    const navigate = useNavigate();
    const [loading,setLoading] = useState(false);
    const [roleData,setRoleData] = useState([]);
    const [openModel,setOpenModel] = useState(false);

    const fetchRoleAndPermissionList = async ()=>{
        setLoading(true)
        try {
        const roleListResponse = await RoleAndPermissionServices.roleList();
        // console.log("fetching role list response:",roleListResponse);
        const data = roleListResponse.permissionArr;
        if(roleListResponse.success=='1'){
            setRoleList(data);
            const updatedRoledata = data.find(role=>role.roleId == selectedRole.roleId);
            setSelectedRole(updatedRoledata);
        }
        } catch (error) {
            Swal.fire(error.message,'','error')
        }finally{
        setLoading(false)
        }
    };
    
    /******************* this is called when close button or discard button of edit modal is open from view  **********************/
    const handleClose=()=>{
        // console.log("close handle hitted");
        setOpenModel(false);
        // console.log("selected role:",selectedRole);
        // console.log("role list:",roleList);
        fetchRoleAndPermissionList();
    }

    const handleBack=()=>{
        setSelectedRole(null);
        setActionTab(0);
    }
  return (
    <>
        {/* =========== pop up models like edit services and sub services=============== */} 
        <Modal
            open={openModel}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ overflow: "auto" }}
            >
            <Box
                sx={{
                ...style,
                width: isMobile ? "95%" : "75%",
                maxHeight: "90vh", // Max height for the modal
                overflowY: "auto", // Enable scrolling within the modal
                // display: "flex",
                // flexDirection: "column",
                p:0
                }}
            >
                <AddRole onClose={handleClose} />
            </Box>
        </Modal>
        {/* ================= page title section and containing add service/sub service button============ */}
        <PageHeaderLayout headerTitle={`${selectedRole?.roleName} Permissions`}>
            <PermissionGuard feature={'roles-and-permissions'} permission='canEdit'>
                <Button variant='outlined' onClick={() => setOpenModel(true)} size='small' startIcon={<EditOutlined />} color='warning'>
                    Edit Role
                </Button>
            </PermissionGuard>
            <Button variant='outlined' onClick={handleBack } size='small' startIcon={<ArrowBack />}>
                Back
            </Button>
        </PageHeaderLayout>
        <Grid container spacing={1}>            
            <Grid item xs={12}>
                <Card sx={{}}>
                    <CardContent sx={{py:1,minHeight:200,position:'relative'}} >

                       {loading && (
                            <LoadingOverlay 
                                message="Loading Related Permissions..."
                                blur={true}
                                opacity={0.7}
                                spinnerSize={48}
                            />
                        )}
                        <Permissions permissions={selectedRole?.permissions}/>
                    
                    </CardContent>
                    
                </Card>
                
            </Grid>
            {/* <Grid item xs={12}>
                <UserList/>
            </Grid> */}
        </Grid>
    </>
  );
}

export default ViewRole;
